import { keyProjects, useStore } from "hooks/useStore";
import ProjectDto from "types/ProjectDto";

interface StoreValues {
  projectId: string;
  slugName: string;
  imported: boolean;
  projectName: string;
  searchable: boolean;
  setValue: (key: keyof StoreValues, value: unknown) => void;
  setProject: (project: ProjectDto) => void;
}

export default function useProjectManagementStore() {
  const { projectId, slugName, projectName, setProject } = useStore(
    (store) => store[keyProjects],
  ) as StoreValues;

  return {
    projectId,
    slugName,
    projectName,
    setProject,
  };
}
